module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-14.dbb37920.png";